export const REFERRAL_SOURCES = Object.freeze([
	{ value: "facebook", label: "Facebook" },
	{ value: "x", label: "X" },
	{ value: "google_play", label: "Google Play" },
	{ value: "apple_app_store", label: "Apple App Store" },
	{ value: "other", label: "Other" },
])

const REFERRAL_SOURCE_LABELS = new Map(
	REFERRAL_SOURCES.map(({ value, label }) => [value, label])
)

export const normalizeReferralSource = (value) =>
	typeof value === "string" ? value.trim().toLowerCase() : ""

export const normalizeReferralSourceOther = (value) =>
	typeof value === "string" ? value.trim() : ""

export function validateReferralDetails({
	referralSource,
	referralSourceOther,
} = {}) {
	const source = normalizeReferralSource(referralSource)
	if (!source) return "Please select how you heard about us."
	if (!REFERRAL_SOURCE_LABELS.has(source)) {
		return "Please select a valid referral source."
	}

	if (source === "other") {
		const other = normalizeReferralSourceOther(referralSourceOther)
		if (!other) return "Please tell us how you heard about us."
		if (other.length > 160) {
			return "Your referral source must be 160 characters or fewer."
		}
	}

	return null
}

export function formatReferralSource(referralSource, referralSourceOther) {
	const source = normalizeReferralSource(referralSource)
	const label = REFERRAL_SOURCE_LABELS.get(source)
	if (!label) return "Not provided"

	if (source === "other") {
		const other = normalizeReferralSourceOther(referralSourceOther)
		return other ? `${label}: ${other}` : label
	}

	return label
}
